<template>
    <div :class="progressClass">
        <div :style="barStyle" :class="progressBarClass"></div>

        <div class="progress__icon">
            <svg><use xlink:href="#picture-success" /></svg>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            percentage: { type: Number, required: true },
            isBarHidden: { type: Boolean, default: false },
            isRounded: { type: Boolean, default: true },
            height: { type: String, default: 'medium' },
            color: { type: String, default: 'primary' },
            showSuccessIcon: { type: Boolean, default: true },
        },

        computed: {
            barStyle() {
                return {
                    width: `${this.percentage}%`,
                }
            },

            progressClass() {
                return {
                    progress: true,
                    'progress--is-bar-hidden': this.isBarHidden,
                    'progress--is-completed': this.percentage === 100 && this.showSuccessIcon,
                    'progress__not-round': !this.isRounded,
                }
            },

            progressBarClass() {
                return {
                    progress__bar: true,
                    [`progress__bar--height-${this.height}`]: true,
                    [`progress__bar--color-${this.color}`]: true,
                    'progress__not-round': !this.isRounded,
                }
            },
        },
    }
</script>
